import { ChangeDetectionStrategy, Component } from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-not-found',
  imports: [I18NextPipe],
  templateUrl: './not-found.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPage {

}
